import React, {ComponentProps, FC, PropsWithChildren} from 'react';
import {AppContextProvider as ApplicationContextProvider} from './AppContext';
import {AuthContextProvider} from './AuthContext';
import {ModuleContextProvider} from './ModuleContext';
import {SelectedCheckBoxProvider} from './SelectedCheckBoxContext';
import {SelectedAdditionalCheckBoxProvider} from './SelectedAdditionalCheckBoxContext';
import {SelectedPatientAccountingCheckBoxProvider} from './SelectedPatientAccountingBoxContext';
import {SelectedDocumentProvider} from './SelectedDocumentContext';
import {SelectedDicomProvider} from './SelectedDicomContext';
import {ModulePreviewContextProvider} from './ModulePreviewContextProvider';

const combineComponents = (...components: FC<any>[]): FC => {
  return components.reverse().reduce(
    (AccumulatedComponents, CurrentComponent) => {
      return ({
        children
      }: PropsWithChildren<ComponentProps<FC>>): JSX.Element => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },
    ({children}) => children
  );
};

// THE ORDER OF PROVIDERS IS EXTREMELY IMPORTANT HERE!
// CHANGING THIS WILL CAUSE THE APP TO DO ZOOMBA! BE CAREFUL!
const PROVIDERS = [
  ApplicationContextProvider,
  AuthContextProvider,
  ModuleContextProvider,
  SelectedCheckBoxProvider,
  SelectedPatientAccountingCheckBoxProvider,
  SelectedAdditionalCheckBoxProvider,
  SelectedDocumentProvider,
  SelectedDicomProvider,
  ModulePreviewContextProvider
];

export const GlobalContextProvider = combineComponents(...PROVIDERS);
